import { render } from "./CalendarioFaenas.vue?vue&type=template&id=2d58b83e"
import script from "./CalendarioFaenas.vue?vue&type=script&lang=js"
export * from "./CalendarioFaenas.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__